import { useQuery } from '@tanstack/react-query'
import { getApiClient } from '@/lib/api'
import type { KpiSummaryResponse, KpiStatsResponse } from '@/types/api'

/**
 * KPI Summary を取得するフック
 * 提案採択率・無視率・再提案成功率・週次トレンドを返す
 */
export function useKpiSummary() {
  return useQuery<KpiSummaryResponse>({
    queryKey: ['kpi', 'summary'],
    queryFn: () => getApiClient().getKpiSummary(),
    // 5分ごとに更新
    staleTime: 5 * 60 * 1000,
  })
}

/**
 * KPI Stats を取得するフック
 * 日別・ステータス別・テンプレート別の統計を返す
 */
export function useKpiStats(period: 'week' | 'month' = 'week') {
  return useQuery<KpiStatsResponse>({
    queryKey: ['kpi', 'stats', period],
    queryFn: () => getApiClient().getKpiStats(period),
    // 5分ごとに更新
    staleTime: 5 * 60 * 1000,
  })
}
